import { createActions } from '@manager-base/app-base/config/data-access';
import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';

const actions = {
    getEligibility: {
        method: 'GET',
        url: `${BASE_PATH_API}/marketplace/eligibility`
    },
    getIntegrationInfo: {
        method: 'POST',
        url: `${BASE_PATH_API}/marketplace/:Id/integrationurl`
    },
    getUpgradePlan: {
        method: 'GET',
        url: `${BASE_PATH_API}/marketplace/:id/upgradePlan`
    },
    upgradeApp: {
        method: 'PUT',
        url: `${BASE_PATH_API}/installedApps/:OpenApiPartnerId/upgrade`
    },
    getInstalledApps: {
        method: 'GET',
        url: `${BASE_PATH_API}/installedApps`
    },
    getMarketplaceRedirectUrl: {
        method: 'GET',
        url: `${BASE_PATH_API}/marketplace/marketplaceredirecturl`
    },
    getOpenApiPartnerAppInstallDTO: {
        method: 'GET',
        url: `${BASE_PATH_API}/marketplace/:id/getOpenApiPartnerAppInstallDTO`
    },
    getInstalledAppById: {
        method: 'GET',
        url: `${BASE_PATH_API}/installedApps/:id`
    },
    getAppKey: {
        method: 'GET',
        url: `${BASE_PATH_API}/accessKeys/?:filterString`
    },
    getPartnerKeyPermissions: {
        method: 'GET',
        url: `${BASE_PATH_API}/accessKeys/:id`
    },
    deleteMarketplaceApp: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/installedApps/:id`
    }
};

export function MarketplaceApi() {
    return createActions(actions);
}
